import 'css-chunksrc/client/scenes/strategicAxisRemoval/styles.scss';export default {
  "header": "_header_x28l6_1",
  "main": "_main_x28l6_5",
  "group": "_group_x28l6_12",
  "text": "_text_x28l6_16",
  "buttons": "_buttons_x28l6_21"
};